import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, connect } from 'react-redux';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { useNavigation } from '../../../../shared/utils/useNavigation';
import { fetchAllCategoriesWithSub } from '../../../../shared/actions/categoryAction';
import { updateUser as updateUserAction, fetchUser } from '../../../../shared/actions/userActions';
import ProfileTagsComponent from '../../Auth/creatorSignup/profileTags';
import * as SwalHandled from '../../../../shared/utils/swalHandler';
import { showManualSuccessPushToast } from '../../../../shared/pusNotification/useManualToasts';

const ProfileTags = ({
  user: userProfile
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigation();

  const [categories, setCategories] = useState({});
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // Form declaration
  const form = useForm({
    defaultValues: {
      selectedTags: [],
    },
    mode: 'onChange',
  });

  // Fetch categories on component mount
  useEffect(() => {
    const fetchCategories = async () => {
      setCategoriesLoading(true);
      try {
        const response = await fetchAllCategoriesWithSub();
        if (response.success) {
          setCategories(response.data);
        } else {
          toast.error(response.error || 'Failed to load categories. Please try again.');
        }
      } catch (error) {
        toast.error('Failed to load categories. Please try again.');
      } finally {
        setCategoriesLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // Initialize form selectedTags from user's current categories
  useEffect(() => {
    if (userProfile?.categories && Array.isArray(userProfile.categories)) {
      form.reset({
        selectedTags: userProfile.categories,
      });
    }
  }, [userProfile, form]);

  // Handle selected tags from ProfileTags component
  const handleTagsSelected = useCallback(async () => {
    const tags = form.getValues('selectedTags') || [];
    setSaving(true);
    try {
      const result = await dispatch(updateUserAction({ categories: tags }));

      if (!result?.success) {
        throw new Error(result?.error || result?.message || 'Failed to update profile tags.');
      }

      // Refresh user data to get updated categories
      await dispatch(fetchUser());

      showManualSuccessPushToast('Updated!', 'Tags updated successfully.', userProfile);
    } catch (error) {
      await SwalHandled.showError(
        'Error',
        error.response?.data?.message ||
        error.message ||
        'Failed to update profile tags. Please try again.'
      );
    } finally {
      setSaving(false);
    }
  }, [dispatch, form, userProfile]);

  const goToBack = useCallback(() => {
    try {
      navigate.back();
    } catch (error) {
      // Fallback to discover page on error
      navigate.toDiscover();
    }
  }, [navigate]);

  return (
    <div className="profile-tags-screen">
      <ProfileTagsComponent
        form={form}
        title="Tags"
        buttonText="Save"
        onContinue={handleTagsSelected}
        onBack={goToBack}
        categories={categories}
        loading={categoriesLoading}
        saving={saving}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user?.user,
  };
};
export default connect(mapStateToProps)(ProfileTags);
